import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { getAddress } from 'lib/smava/address-line-helper';
import { SocialIcons } from './SocialIcons';
import { FooterLink, Links } from './Links';
import { Logo } from './Logo';

export interface FooterTemplateProps {
  oneTrustHandler?: () => void;
  footerLinks: FooterLink[];
  logoLink?: string;
  showSocialIcons?: boolean;
  showAddress?: boolean;
}

export function FooterTemplate(props: FooterTemplateProps) {
  const {
    oneTrustHandler,
    logoLink,
    footerLinks,
    showSocialIcons = true,
    showAddress = true,
  } = props;

  return (
    <Box
      sx={{
        bgcolor: 'common.white',
        display: 'flex',
        justifyContent: { xs: 'flex-start', md: 'space-between' },
        alignItems: { xs: 'flex-start', md: 'center' },
        flexDirection: { xs: 'column', md: 'row' },
        px: (theme) => ({ xs: theme.spacing(2), md: theme.spacing(3) }),
        py: (theme) => ({ xs: theme.spacing(3), md: theme.spacing(2) }),
        m: 'auto',
        gap: (theme) => theme.spacing(3),
        maxWidth: 'lg',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Logo logoLink={logoLink} />

        {showSocialIcons && (
          <Box
            sx={{
              display: { xs: 'none', sm: 'block', md: 'none' },
              ml: (theme) => theme.spacing(4),
            }}
          >
            <SocialIcons />
          </Box>
        )}
      </Box>
      {showSocialIcons && (
        <Box
          sx={{
            display: { xs: 'block', sm: 'none', md: 'block' },
          }}
        >
          <SocialIcons />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: (theme) => theme.spacing(0.5),
        }}
      >
        <Links oneTrustHandler={oneTrustHandler} links={footerLinks} />
        {showAddress && (
          <>
            <Box
              sx={{
                mt: (theme) => ({ xs: theme.spacing(1), sm: '0' }),
              }}
            >
              <Typography
                variant="body2"
                suppressHydrationWarning
                sx={{
                  color: 'grey.900',
                  textAlign: { xs: 'left', md: 'right' },
                }}
              >
                {getAddress()}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
